import { ITableAdapter } from '../../../../../../generic/universal-table/types/adapter.types'
import {
  CustomerApiRow,
  CustomerCreatePayload,
  CustomerUiRow,
  CustomerUpdatePayload,
} from '../types/customerTable.types'

export const customerTableAdapter: ITableAdapter<
  CustomerApiRow,
  CustomerUiRow,
  CustomerCreatePayload,
  CustomerUpdatePayload
> = {
  fromApi: (row: CustomerApiRow): CustomerUiRow => ({
    Active: row.Active ?? false,
    AllowBouncing: row.AllowBouncing ?? false,
    Blocked: row.Blocked ?? false,
    ClientID: row.ClientID ?? 0,
    Color: row.Color?.trim() ?? '',
    Company: row.Company ?? 0,
    Cosher: row.Cosher ?? 0,
    CustomerGroupID: row.CustomerGroupID ?? 0,
    CustomerID: row.CustomerID,
    CustomerName: row.CustomerName?.trim() ?? '',
    CustomerType: row.CustomerType?.trim() ?? '',
    DeliveryCode: row.DeliveryCode ?? 0,
    DeliveryPrice: row.DeliveryPrice ?? false,
    Friday: row.Friday ?? false,
    LandTransp: row.LandTransp ?? 0,
    MarketingAreaID: row.MarketingAreaID ?? 0,
    Meher: row.Meher ?? 0,
    Monday: row.Monday ?? false,
    NeedGrowthGroup: row.NeedGrowthGroup ?? 0,
    OneMany: row.OneMany ?? 0,
    PackUsage: row.PackUsage ?? false,
    Phone: row.Phone?.trim() ?? '',
    PickupGroup: row.PickupGroup ?? 0,
    PickupWarehouse: row.PickupWarehouse ?? 0,
    PriceList: row.PriceList ?? false,
    PriceListID: row.PriceListID ?? 0,
    RampId: row.RampId ?? 0,
    ResellerID: row.ResellerID ?? 0,
    Saturday: row.Saturday ?? false,
    SavedPriceToOrderProduct: row.SavedPriceToOrderProduct ?? false,
    ShippAddress: row.ShippAddress?.trim() ?? '',
    TransferPallets2Warehouse: row.TransferPallets2Warehouse ?? 0,
    TransferResetCustomerID: row.TransferResetCustomerID ?? false,
    TrasportationMethod: row.TrasportationMethod ?? 0,
    Tuesday: row.Tuesday ?? false,
    WarehouseID: row.WarehouseID ?? 0,
    Wednesday: row.Wednesday ?? false,
    has_levies: row.has_levies ?? 0,
  }),

  toCreatePayload: ({
    CustomerID: _,
    ...rest
  }: CustomerUiRow): CustomerCreatePayload => rest,

  toUpdatePayload: ({
    CustomerID: _,
    ...rest
  }: CustomerUiRow): CustomerUpdatePayload => rest,

  getRowId: (row: CustomerUiRow): number => row.CustomerID,
}
